import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Section from '../../common/Section';
import Hero from './Hero';
import Carousel from './Carousel';
import Anchor from '../utils/Anchor';

const HeroBlockCarousel = ({ content }) => {
  const { blockId, blocks } = content;
  return (
    <React.Fragment>
      <Anchor id={blockId} />
      <Section>
        <Carousel>
          {blocks &&
            blocks.map((block, index) => {
              if (get(block, 'fields')) {
                return <Hero key={index} content={block.fields} />;
              }
              return null;
            })}
        </Carousel>
      </Section>
    </React.Fragment>
  );
};

HeroBlockCarousel.propTypes = {
  content: PropTypes.object,
};

export default HeroBlockCarousel;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/heroBlock/HeroBlockCarousel.js